<template>
    <a class="download">
        <span class="download__text">
            {{ $t('DOWNLOAD_ON_THE') }}
        </span>
        <img :src="require(`@/assets/appstore-download-${theme}.svg`)" class="download__img" />
    </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['theme']),
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/variables";

.download {
    display: block;
    position: relative;

    &__text {
        display: block;
        width: 75px;
        overflow: hidden;
        text-overflow: ellipsis;
        position: absolute;
        left: 35px;
        top: 7px;
        font-size: 9px;
        line-height: 9px;
        color: var(--text-primary);
    }

    &__img {
        display: block;
    }
}
</style>
